/**
 * R-8 — versioned prompt template for qualitative claim vs evidence judge.
 */
export const QUALITATIVE_CLAIM_JUDGE_PROMPT_VERSION = '2026-05-26.v1';

export interface QualitativeClaimJudgeInput {
  claimText: string;
  sectionId: string;
  citedReferences: Array<{ index: number; source: string; field?: string; excerpt: string }>;
  sedExcerpt: string;
}

export function buildQualitativeClaimJudgePrompt(input: QualitativeClaimJudgeInput): string {
  const refsBlock = input.citedReferences.length > 0
    ? input.citedReferences.map((r) =>
      `[Ref ${r.index}] ${r.source}${r.field ? ` (${r.field})` : ''}: ${r.excerpt}`,
    ).join('\n')
    : '(no cited references parsed)';

  return [
    `Prompt version: ${QUALITATIVE_CLAIM_JUDGE_PROMPT_VERSION}`,
    'You are a report QA auditor. Judge whether a QUALITATIVE CLAIM in a site feasibility report',
    'is supported by the cited references and Site Evidence Document (SED) excerpts provided.',
    '',
    'Return JSON only with fields:',
    '- verdict: "CONFIRMED" | "UNSUPPORTED" | "CONTRADICTED"',
    '- rationale: one concise sentence explaining the verdict',
    '- sedFieldsConsidered: string array of SED field paths you relied on (may be empty)',
    '',
    'Verdict rubric:',
    '- CONFIRMED: cited evidence reasonably supports the qualitative characterization',
    '- UNSUPPORTED: evidence is missing, too thin, or unrelated to the claim',
    '- CONTRADICTED: evidence directly contradicts the qualitative characterization',
    '',
    `Section: ${input.sectionId}`,
    '',
    'QUALITATIVE CLAIM:',
    input.claimText,
    '',
    'CITED REFERENCES:',
    refsBlock,
    '',
    'SED EXCERPT:',
    input.sedExcerpt.slice(0, 4000) || '(no SED excerpt available)',
  ].join('\n');
}
